import {
  CHANGE_PAGE,
  CHANGE_SEARCH_TEXT,
  CHANGE_BROKER_FILTER,
  CHANGE_REFERRAL_SOURCE_FILTER,
  CHANGE_STATUS_FILTER,
  CHANGE_WAITLIST_FILTER,
  CHANGE_PROFILE_USER_TYPE_FILTER,
  CHANGE_SORT,
  CLEAR_FILTERS,
  CHANGE_PROPERTY_FILTER,
  CHANGE_CA_STATUS_FILTER,
  CHANGE_COMPANY_FILTER,
  CHANGE_MULTIPLE_FILTERS,
  CHANGE_START_DATE,
  CHANGE_END_DATE
} from '../actions/query';

export default function(state = {}, action) {
  switch (action.type) {
  case CHANGE_PAGE:
    return {
      ...state,
      page: action.page
    };
  case CHANGE_SEARCH_TEXT:
    return {
      ...state,
      searchText: action.value,
      page: 1
    };
  case CHANGE_BROKER_FILTER:
    return {
      ...state,
      brokerFilter: action.brokerFilter,
      page: 1
    };
  case CHANGE_REFERRAL_SOURCE_FILTER:
    return {
      ...state,
      referralSourceFilter: action.referralSourceFilter,
      page: 1
    };
  case CHANGE_STATUS_FILTER:
    return {
      ...state,
      statusFilter: action.statusFilter,
      page: 1
    };
  case CHANGE_WAITLIST_FILTER:
    return {
      ...state,
      waitlistFilter: action.waitlistFilter,
      page: 1
    };
  case CHANGE_PROFILE_USER_TYPE_FILTER:
    return {
      ...state,
      profileUserTypeFilter: action.profileUserTypeFilter,
      page: 1
    };
  case CHANGE_SORT:
    return {
      ...state,
      sort: { ...action.sort },
      page: 1
    };
  case CHANGE_PROPERTY_FILTER:
    return {
      ...state,
      propertyFilter: action.propertyFilter,
      page: 1
    };
  case CHANGE_CA_STATUS_FILTER:
    return {
      ...state,
      caStatusFilter: action.caStatusFilter,
      page: 1
    };
  case CHANGE_COMPANY_FILTER:
    return {
      ...state,
      companyFilter: action.companyFilter,
      page: 1
    };
  case CHANGE_START_DATE:
    return {
      ...state,
      startDate: action.updatedDate,
      page: 1
    };
  case CHANGE_END_DATE:
    return {
      ...state,
      endDate: action.updatedDate,
      page: 1
    };
  case CHANGE_MULTIPLE_FILTERS:
    return {
      ...state,
      ...action.filters,
      page: 1
    };
  case CLEAR_FILTERS:
    return {
      ...state,
      searchText: '',
      brokerFilter: [],
      statusFilter: [],
      referralSourceFilter: [],
      waitlistFilter: [],
      profileUserTypeFilter: [],
      propertyFilter: [],
      caStatusFilter: [],
      companyFilter: [],
      startDate: null,
      endDate: null,
      page: 1
    };
  default:
    return state;
  }
}
